module.exports = __webpack_public_path__ + "static/media/steps-desktop.31a468c3.svg";